<template>
    <div class="card landing_card">
        <div class="p-d-flex p-jc-center p-ai-center">
            <img class="checkinout-logo" src="/assets/layout/images/logo.svg" alt="ProAstra">
        </div>
        <a v-if="user.data.role.permissionLevel >= 10" class="p-button text-center" href="/">Go to Dashboard</a>
        <a v-else class="p-button text-center" :href="'/sites/' + user.data.client.key">Continue</a>
    </div>
</template>

<script>
import { db } from '@/firebase';
import { mapGetters } from "vuex";

export default {
    data() {
        return {
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        }),
    },
    created() {
        // console.log(this.user)
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
.p-button {
    background-color: #2196F3 !important;
    border-color: #2196F3 !important;
    display: table;
    margin: 0 auto;
    margin-top: 2rem;

}

.landing_card {
    margin: 0px auto;
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    z-index: 999;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>